import { ApolloClient, InMemoryCache, HttpLink, DefaultOptions } from '@apollo/client';

const defaultOptions: DefaultOptions = {
    query: {
        fetchPolicy: 'no-cache',
    },
    watchQuery: {
        fetchPolicy: 'no-cache',
    },
    mutate: {
        fetchPolicy: 'no-cache',
    },
};

export const executeQuery = new ApolloClient({
    link: new HttpLink({
        uri: process.env['NEXT_PUBLIC_DATOCMS_ENVIRONMENT']
            ? `https://graphql.datocms.com/environments/${process.env['NEXT_PUBLIC_DATOCMS_ENVIRONMENT']}`
            : 'https://graphql.datocms.com/', //
        headers: {
            authorization: `Bearer ${process.env['NEXT_PUBLIC_DATOCMS_PUBLISHED_CONTENT_CDA_TOKEN']}`,
        },
    }),
    cache: new InMemoryCache(),
    defaultOptions,
});
